import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css'
import AppWithRouter from '@src/routes'; 
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <AppWithRouter />
);